// extracted by mini-css-extract-plugin
export default {"brandPromo":"lO-z","carousel":"mO-z"};